import { render, staticRenderFns } from "./editFormParam.vue?vue&type=template&id=e585affa&"
import script from "./editFormParam.vue?vue&type=script&lang=js&"
export * from "./editFormParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports